/* @flow */
// typecheck: ignore file
import React from 'react';
import Box from 'components/Box.jsx';
import Field from 'components/Field.jsx';
import Button from 'components/Button.jsx';
import { debounce } from 'lodash';
import MailTo from 'components/MailTo.jsx';
import BoxBody from 'components/BoxBody.jsx';
import BoxHeader from 'components/BoxHeader.jsx';
import BoxFooter from 'components/BoxFooter.jsx';
import CenteredContainer from 'components/CenteredContainer.jsx';
import PrependedTextInput from 'components/PrependedTextInput.jsx';
import SettingsActions from 'actions/SettingsActions';
import Group from 'entities/Group';
import GroupActions from 'groups/actions/GroupActions';
import LinkConstants from 'constants/LinkConstants';

import './styles/JoinSearchPage.scss';

type State = {
  group: ?Group,
  error: ?string,
  disabled: boolean,
  showLegalFooter: boolean,
  searching: boolean,
  value: string,
}

export default class JoinSearchPage extends React.Component {
  state: State = {
    group: null,
    error: null,
    disabled: true,
    showLegalFooter: false,
    searching: false,
    value: '',
  }

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  componentWillMount() {
    const notFoundCode = this.context.router.location.query.notFound || '';
    if (notFoundCode) {
      this.onNotFound();
      this.setState({ value: notFoundCode });
    }
  }

  componentDidMount() {
    const onGeoReceived = (geo) => {
      if (geo.country_code === 'US') {
        this.setState({ showLegalFooter: true });
      }
    };

    SettingsActions.getGeo()
      .then(onGeoReceived, () => {});
  }

  onInputChange = (e: SyntheticEvent) => {
    this.setState({ group: null, error: null, disabled: true });

    // TODO - cannot use regex from settings because JS does not support \A
    let code = '';
    if (e.target instanceof window.HTMLInputElement) {
      code = e.target.value.replace(/[^a-z0-9-]/gi, '');
      this.setState({ value: code });
    }

    if (code.length < 3) {
      return;
    }

    this.setState({ searching: true });
    this.searchGroupByCode(this, code);
  }

  onSubmit = () => {
    if (this.state.group) {
      this.context.router.push(`/join/${this.state.group.getCode()}`);
    }
  }

  onNotFound = () => {
    const error = `
      Uh oh! We couldn’t find a class matching this code.
      Every class has a unique code. Please contact your
      teacher to double check instructions for your class.`;

    this.setState({ group: null, disabled: true, error, searching: false });
  }

  searchGroupByCode = debounce((component, code) => {
    const onFound = (group) => {
      component.setState({ group, disabled: false, searching: false });
    };

    GroupActions
      .searchGroupByCode(code)
      .then(onFound, this.onNotFound);
  }, 1000);

  renderLegalFooter() {
    if (!this.state.showLegalFooter) {
      return null;
    }

    return (
      <BoxFooter className="JoinSearchPage-Footer">
        <p>
          Remind uses the short code, 81010, to send alerts from
          teachers to students and parents. You may opt-in by using this
          Join page or by texting the class code directly to 81010.
          You may opt-out at any time by texting STOP to 81010.
        </p>

        <p>
          Message frequency may vary by class.
          Standard message & data rates may apply.
        </p>

        <p>
          Text HELP to 81010 for additional information.{' '}
          <MailTo to={LinkConstants.CONTACT_EMAIL} />
        </p>
      </BoxFooter>
    );
  }

  render() {
    return (
      <CenteredContainer size="small">
        <Box className="JoinSearchPage">
          <BoxHeader title="Find your class" />
          <BoxBody>
            <Field error={this.state.error} loading={this.state.searching}>
              <PrependedTextInput
                data-test-selector="join_search_input"
                value={this.state.value}
                onChange={this.onInputChange}
                placeholder="Class code"
                autofocus
                prepend="@"
                type="text"
              />
            </Field>

            <Button
              onClick={this.onSubmit}
              data-test-selector="join_search_submit"
              disabled={this.state.disabled}>
              {
                this.state.group ?
                  `Join ${this.state.group.getPossessiveName()}` :
                  'Enter'
              }
            </Button>
          </BoxBody>
          {this.renderLegalFooter()}
        </Box>
      </CenteredContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/join/components/JoinSearchPage.jsx